import React, { useCallback, useState } from "react";
import { ClickAwayListener, Collapse, createStyles, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { login } from "../../../../lib/sso";
import { useHeaderConfig } from "../../NavProvider";
import { useAuth } from "../../AuthProvider";
import { trackMainNavEvent } from "../analytics";
import { AvatarIcon } from "../../../icons";
import SsoMenu from "./SsoMenu";
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        container: {
            display: "flex",
            alignItems: "center",
            height: 40,
            fontSize: 0,
            color: "#fff",
            cursor: "pointer",
            outline: "none",
            userSelect: "none",
        },
        cta: {
            display: "inline-block",
            marginLeft: 8,
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: 0.3,
            "&::before": {
                display: "block",
                content: "attr(data-title)",
                visibility: "hidden",
                overflow: "hidden",
                height: 0,
                fontWeight: "bold",
                letterSpacing: 0.3,
            },
        },
        open: {
            fontWeight: "bold",
            letterSpacing: "normal",
            textShadow: "0 0 #fff",
            WebkitFontSmoothing: "subpixel-antialiased",
        },
        menu: (_a = {
                position: "absolute",
                top: "calc(100% - 4px)",
                right: 0,
                backgroundColor: "#010414",
                borderRadius: 8
            },
            _a[theme.breakpoints.up("md")] = {
                top: "calc(100% + 8px)",
            },
            _a),
    });
});
var SsoButton = function () {
    var _a = useHeaderConfig().sso, navItem = _a.navItem, navItemAuthenticated = _a.navItemAuthenticated;
    var _b = useAuth(), authenticated = _b.authenticated, loginUrl = _b.loginUrl, onLogin = _b.onLogin;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var styles = useStyles({ open: open, authenticated: authenticated });
    var handleMenuOpen = useCallback(function () {
        if (authenticated) {
            // toggle profile menu
            setOpen(function (state) { return !state; });
        }
        else {
            // login process
            trackMainNavEvent("Login");
            onLogin && onLogin();
            login(loginUrl);
        }
    }, [authenticated, loginUrl, onLogin]);
    var handleMenuClose = function () { return setOpen(false); };
    var handleClickInsideMenu = function (event) {
        event.stopPropagation();
    };
    var navItemId = authenticated ? "headerProfile" : "headerLogin";
    var navItemText = authenticated ? navItemAuthenticated : navItem;
    return (React.createElement(ClickAwayListener, { onClickAway: handleMenuClose, mouseEvent: open ? "onClick" : false, touchEvent: open ? "onTouchStart" : false },
        React.createElement("div", { className: styles.container, onClick: handleMenuOpen, id: navItemId },
            React.createElement(AvatarIcon, null),
            React.createElement("span", { className: clsx(styles.cta, open && authenticated && styles.open), "data-title": navItemText }, navItemText),
            React.createElement("div", { className: styles.menu, onClick: handleClickInsideMenu },
                React.createElement(Collapse, { in: open, timeout: 150 },
                    React.createElement(SsoMenu, { onItemClick: handleMenuClose }))))));
};
export default SsoButton;
